export const SET_NATUREZA_COLLECTION = 'NATUREZA/SET_NATUREZA_COLLECTION';
